import React, { memo, useEffect, useRef, useState } from 'react'

import Layout from '../../../components/Layout'
import Welcome from '../../../components/Welcome'
import RecoveryJourney from './RecoveryJourney'
import Button from '../../../components/ButtonNew'
import OurProgram from './OurProgram'
import OurStories from './OurStories'
import Highlights from './Highlights'
import Faqs from './Faqs'
import Copyrights from './Copyrights'

import { useNavigate } from 'react-router-dom'

import { getUrlParams } from '../../../utils/helpers/common'
import { trackEvent } from '../../../analytics'
import { EVENTS } from '../../../analytics/events'
import constants from '../../../constants'
import { deeplinks } from '../../../constants/common'

import ArrowRight from '../../../assets/icons/common/arrow-right.svg'
import MetaTags from '../../../components/MetaTags/MetaTags'
import { viemaxImgUrls } from '../../../constants/viemax-constants'
import useSetTheme from '../../../hooks/useSetTheme'

const ViemaxProgramPage = () => {
  const navigate = useNavigate()
  const [urlParams, setUrlParams] = useState(null)
  const innerRef = useRef(null)
  const [addbottom, setBottom] = useState()
  useSetTheme()
  const deeplinkToRedirect = deeplinks[constants.CARE_PROGRAM_TYPE.VIEMAX]

  useEffect(() => {
    const urlParams = getUrlParams()
    setUrlParams(urlParams)
    trackEvent(EVENTS.PAGE_VIEW, {
      screenName: 'Programs Screen',
      pageName: 'Viemax Care Program',
      ...urlParams,
    })
  }, [])

  useEffect(() => {
    const div = innerRef.current
    // subscribe event
    div.addEventListener('scroll', handleOnScroll)
    return () => {
      // unsubscribe event
      div.removeEventListener('scroll', handleOnScroll)
    }
  }, [])

  const handleOnScroll = (e) => {
    // NOTE: This is for the sake of demonstration purpose only.
    // Doing this will greatly affect performance.
    e.target.scrollTop >= 625 ? setBottom(true) : setBottom(false)
  }

  const handleJoinProgramClick = () => {
    localStorage.removeItem('auth_token')
    navigate(
      `/psp/signup-user?support_program_type=${constants.CARE_PROGRAM_TYPE.VIEMAX}`,
    )
  }

  return (
    <Layout>
      <MetaTags
        title="Viemax Care Program"
        description="Viemax Care Program"
        image={viemaxImgUrls.heroSection}
        url={window.location.href}
        type="website"
        siteName="GoodFlip"
      />

      <div
        className="container h-[100vh]"
        style={{ padding: 0, overflow: 'auto' }}
        ref={innerRef}
      >
        <div className="min-w-sm max-w-lg pb-[98px] relative mx-auto w-full bg-white">
          <div>
            <Welcome
              careProgramType={constants.CARE_PROGRAM_TYPE.VIEMAX}
              welcomeImage={viemaxImgUrls.heroSection}
              storeUrl={deeplinkToRedirect}
              hideDownloadBtn={
                urlParams?.source === 'mytatva' && urlParams?.platform === 'app'
              }
              buttonText="Join the Program"
              onButtonClick={handleJoinProgramClick}
            />
            <OurProgram />
            <Highlights />
            <OurStories />
            <RecoveryJourney />
            <Faqs />
            <Copyrights />
          </div>
          <div
            className={`min-w-sm max-w-lg w-full mx-auto text-center fixed z-15 bg-white bottom-gray-class ${addbottom ? 'bottom-0' : 'bottom-[-90px]'}`}
            // class="min-w-sm max-w-lg mx-auto fixed bottom-0 left-0 right-0 bg-white p-4"
            style={{
              padding: '15px 0',
            }}
          >
            {(urlParams?.source !== 'mytatva' ||
              urlParams?.platform !== 'app') && (
              <div className="px-4">
                <Button
                  onClick={handleJoinProgramClick}
                  variant="contained"
                  fullWidth
                >
                  Join the Program
                  <img src={ArrowRight} />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default memo(ViemaxProgramPage)
